

import * as utils from './utils.js';

// namespace simplex query builder

var simpleQueryBuilder = {};


// ANW

export function buildAnwQuery(searchTerm){

    // exact or regex match?  
  
    var exactSearch = !utils.containsRegex(searchTerm);

    // values to match 
    
    var subpart = exactSearch ? 
    '{ { ?lemId rdfs:label ?lemma .\n'+
    '  values ?lemma { "'+searchTerm+'"@nl "'+searchTerm+'" } } \n'+
    '  UNION  \n'+
    '  { ?definitionId lemon:value ?definition .\n'+
    '  values ?definition { "'+searchTerm+'"@nl "'+searchTerm+'" } } } .\n'
    :
    'FILTER ( regex(?lemma, "'+searchTerm+'") || regex(?definition, "'+searchTerm+'") ) .\n';

    // query

    return 'PREFIX ontolex: <http://www.w3.org/ns/lemon/ontolex#>\n'+
      'PREFIX anw: <http://rdf.ivdnt.org/lexica/anw>\n'+
      'PREFIX anwsch: <http://rdf.ivdnt.org/schema/anw/>\n'+
      'PREFIX lemon: <http://lemon-model.net/lemon#>\n'+
      '\n'+
      'SELECT (?lemId AS ?colorId) ?lemId ?lemma ?definition ?definitionComplement\n'+
      'WHERE {\n'+
      '    ?lemId rdfs:label ?lemma .\n'+
      '    ?lemId ontolex:sense ?senseId .\n'+
      '    ?senseId lemon:definition ?definitionId .\n'+
      '    ?definitionId lemon:value ?definition .\n'+
      '    FILTER regex(?definition, ".+") .\n'+
      '    OPTIONAL { ?definitionId anwsch:definitionComplement ?definitionComplement .}\n'+
      '    '+subpart+'\n'+
      '    }\n';
};



// CELEX

export function buildCelexQuery(searchTerm){

    // exact or regex match? 

    var exactSearch = !utils.containsRegex(searchTerm);

    // values to match 

    var subpart = exactSearch ? 
            '{ ?lemmaId ontolex:canonicalForm [ontolex:writtenRep ?lemma] . \n'+
            'values ?lemma { "'+searchTerm+'"@nl "'+searchTerm+'" } } . \n' 
            : 
            'FILTER regex(?lemma, "'+searchTerm+'") .\n';

    // query

    return 'PREFIX ontolex: <http://www.w3.org/ns/lemon/ontolex#>\n'+
          'PREFIX celex: <http://rdf.ivdnt.org/lexica/celex/>\n'+
          'PREFIX UD: <http://rdf.ivdnt.org/vocabs/UniversalDependencies2#>\n'+
          'PREFIX decomp: <http://www.w3.org/ns/lemon/decomp#>\n'+
          'PREFIX gold: <http://purl.org/linguistics/gold#>\n'+
          '\n'+
          'SELECT DISTINCT (?lemmaId AS ?colorId) ?lemmaId ?lemma ?wordformId ?wordform ?number ?gender ?subLemmata ?pronunciation \n'+
          'FROM <http://rdf.ivdnt.org/lexica/celex/>\n'+
          'WHERE  {\n'+
          '    ?lemmaId ontolex:canonicalForm [ontolex:writtenRep ?lemma] .\n'+
          '    '+subpart+'\n'+
          '    BIND( ?lemmaId AS ?lemmaIdIRI ).\n'+
          '    ?lemmaId ontolex:lexicalForm ?wordformId .\n'+
          '    ?wordformId ontolex:writtenRep ?wordform .\n'+
          '    OPTIONAL {?wordformId UD:Number ?dcn . \n'+
          '      bind(\n'+
          '        if(?dcn = UD:Plur_Number,\n'+
          '          UD:Plur, UD:Sing\n'+
          '        )\n'+
          '        AS ?number \n'+
          '      )\n'+        
          '    } .\n'+
          '    OPTIONAL {\n'+
          '    	?lemmaId UD:Gender ?g . \n'+
          '    			bind( \n'+
          '    				if(?g = UD:Fem_Gender, \n'+
          '    				    UD:Fem, \n'+
          '    					if(?g = UD:Masc_Gender, \n'+
          '    						UD:Masc, \n'+
          '    					    if(?g = UD:Com_Gender, \n'+
          '    						    UD:Com, \n'+
          '    					        if(?g = UD:Neut_Gender, \n'+
          '    						      UD:Neut, \n'+
          '    						      ?g \n'+
          '    					         ) \n'+
          '    					    ) \n'+
          '    					) \n'+
          '    				) \n'+
          '    				AS ?gender \n'+
          '    			) \n'+
          '    } \n'+
          '    OPTIONAL { \n'+
          '     ?lemmaId ontolex:lexicalForm ?wordformId . \n'+
          '     ?wordformId  ontolex:phoneticRep ?pronunciation . \n'+
          '    } \n'+
          '    OPTIONAL {\n'+
          '     SELECT ?lemmaIdIRI (group_concat(DISTINCT concat(?partNr,":",COALESCE(?subLemma,"[infix]"));separator=" + ") as ?subLemmata) \n'+
          '     FROM <http://rdf.ivdnt.org/lexica/celex/>\n'+
          '     WHERE {\n'+
          '         SELECT ?lemmaIdIRI ?celexComp ?aWordformId ?subLemma ?partNr \n'+
          '         WHERE {\n'+
          '                 {\n'+
          '                 ?lemmaIdIRI ontolex:lexicalForm ?aWordformId . \n'+ 
          '                 ?lemmaIdIRI decomp:constituent ?celexComp . \n'+ 
          '                 OPTIONAL { ?celexComp gold:stem [ontolex:writtenRep ?subLemma] . }\n'+
          '                 OPTIONAL { ?celexComp decomp:correspondsTo [ ontolex:canonicalForm [ontolex:writtenRep ?subLemma]] . }\n'+    
          '                 }\n'+ 
          '                 {\n'+ 
          '                     {\n'+ 
          '                         {?lemmaIdIRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#_1> ?celexComp .}\n'+ 
          '                         UNION\n'+ 
          '                         {?lemmaIdIRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#_2> ?celexComp .}\n'+ 
          '                         UNION\n'+ 
          '                         {?lemmaIdIRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#_3> ?celexComp .}\n'+ 
          '                         UNION\n'+ 
          '                         {?lemmaIdIRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#_4> ?celexComp .}\n'+ 
          '                         UNION\n'+ 
          '                         {?lemmaIdIRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#_5> ?celexComp .}\n'+ 
          '                         UNION\n'+ 
          '                         {?lemmaIdIRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#_6> ?celexComp .}\n'+ 
          '                     }\n'+ 
          '                 ?lemmaIdIRI ?rdfsynt ?celexComp .\n'+
          '                 BIND(IF(STRSTARTS(str(?rdfsynt), "http://www.w3.org/1999/02/22-rdf-syntax-ns#"), replace(STRAFTER(str(?rdfsynt), "#"), "_", ""), "999") AS ?partNr) .\n'+ 
          '                 MINUS {\n'+
          '                     ?lemmaIdIRI <http://www.w3.org/1999/02/22-rdf-syntax-ns#0> ?celexComp .\n'+
          '                     }\n'+
          '                 }\n'+ 
          '             FILTER (?partNr != "999") .\n'+
          '             }\n'+ 
          '         ORDER BY ?partNr \n'+
          '         }\n'+          
          '     GROUP BY ?aWordformId ?lemmaIdIRI \n'+
          '    } \n'+
          '} ORDER BY ?lemmaId ?gender \n';
};



// DUEL-ME


export function  buildDuelMeQuery(searchTerm){

    // exact or regex match? 
  
    var exactSearch = !utils.containsRegex(searchTerm);
  
    // values to match 
  
    var subpart = 'FILTER regex(?multiwordexp, "'+searchTerm+'") .\n';
  
    // query
    
    return 'PREFIX duelme: <http://rdf.ivdnt.org/lexica/duelme>\n'+        
          'PREFIX intskos: <http://ivdnt.org/schema/lexica#>\n'+
          'PREFIX lmf: <http://www.lexinfo.net/lmf>\n'+
          'PREFIX ontolex: <http://www.w3.org/ns/lemon/ontolex#>\n'+
          'PREFIX UD: <http://rdf.ivdnt.org/vocabs/UniversalDependencies2#>\n'+
          'PREFIX prov: <http://www.w3.org/ns/prov#>\n'+
          'PREFIX dcterms: <http://purl.org/dc/terms/>\n'+
          'PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\n'+
          'PREFIX olia: <http://purl.org/olia/olia.owl#>\n'+
          '\n'+
          'SELECT ?lemma  ?lemmaPos ?parts \n'+
          'FROM <http://rdf.ivdnt.org/lexica/duelme> \n'+
          'WHERE {       \n'+
          '  SELECT replace(STRAFTER(str(?multiwordexp), "duelme_"), "_", " ") AS ?lemma ?mwepattern (?syncat AS ?lemmaPos) group_concat(DISTINCT ?subsubcat; separator=" + ") AS ?parts \n'+
          '  WHERE  {  \n'+
          '        { \n'+
          '        SELECT DISTINCT ?multiwordexp ?mwepattern (STRAFTER(str(?trueSynCat), "#") AS ?syncat) (STRAFTER(str(?trueSubsubcat), "#") AS ?subsubcat)  \n'+
          '        FROM <http://rdf.ivdnt.org/lexica/duelme> \n'+
          '        WHERE { \n'+
          '            { \n'+
          '            ?multiwordexp lmf:hasMWEPattern ?mwepattern .       \n'+
          '            ?mwepattern lmf:hasMWENode ?node . \n'+
          '            ?node rdf:type ?syncat . \n'+
          '            filter regex(str(?syncat), "http://purl.org/olia/olia.owl") . \n'+
          '              bind( \n'+
          '                if(?syncat = olia:NounPhrase, \n'+
          '                  olia:NP, \n'+
          '                  if(?syncat = olia:VerbPhrase,  \n'+
          '                    olia:VP,  \n'+
          '                    if(?syncat = olia:Determiner,  \n'+
          '                      olia:DP,  \n'+
          '                      if(?syncat = olia:Verb,  \n'+
          '                        olia:V,  \n'+
          '                        if(?syncat = olia:PrepositionalPhrase,  \n'+
          '                        olia:PP,  \n'+
          '                          if(?syncat = olia:Preposition,  \n'+
          '                          olia:P,  \n'+
          '                            if(?syncat = olia:AdjectivePhrase,  \n'+
          '                            olia:AP,  \n'+
          '                              if(?syncat = olia:SubordicateClause,  \n'+
          '                              olia:SC,  \n'+
          '                              olia:Unknown \n'+
          '                              ) \n'+
          '                            ) \n'+
          '                          ) \n'+
          '                        ) \n'+
          '                      ) \n'+
          '                    ) \n'+
          '                  ) \n'+
          '                ) \n'+
          '                AS ?trueSynCat ) \n'+
          '              ?node lmf:hasMWEEdge ?subnode . \n'+
          '              ?subnode lmf:hasMWENode ?subsubnode . \n'+
          '                ?subsubnode rdf:type ?subsubcat .   \n'+
          '              filter regex(str(?subsubcat), "http://purl.org/olia/olia.owl") . \n'+
          '              bind( \n'+
          '                if(?subsubcat = olia:NounPhrase, \n'+
          '                  olia:NP, \n'+
          '                  if(?subsubcat = olia:VerbPhrase,  \n'+
          '                    olia:VP,  \n'+
          '                    if(?subsubcat = olia:Determiner,  \n'+
          '                      olia:DP,  \n'+
          '                      if(?subsubcat = olia:Verb,  \n'+
          '                        olia:V,  \n'+
          '                        if(?subsubcat = olia:PrepositionalPhrase,  \n'+
          '                        olia:PP,  \n'+
          '                          if(?subsubcat = olia:Preposition,  \n'+
          '                          olia:P,  \n'+
          '                            if(?subsubcat = olia:AdjectivePhrase,  \n'+
          '                            olia:AP,  \n'+
          '                              if(?subsubcat = olia:SubordicateClause,  \n'+
          '                              olia:SC,  \n'+
          '                              olia:Unknown \n'+
          '                              ) \n'+
          '                            ) \n'+
          '                          ) \n'+
          '                        ) \n'+
          '                      ) \n'+
          '                    ) \n'+
          '                  ) \n'+
          '                ) \n'+
          '                AS ?trueSubsubcat ) \n'+
          '                '+subpart+' \n'+
          '                }    \n'+ 
          '        } \n'+
          '        ORDER BY ?partnr \n'+
          '      }  \n'+          
          '    }  \n'+
          '  GROUP BY ?multiwordexp ?mwepattern  ?syncat \n'+
          '}\n';
  };
  

// export function  buildDuelMeQuery(searchTerm){

//   // exact or regex match? 

//   var exactSearch = !utils.containsRegex(searchTerm);

//   // values to match 

//   var subpart = exactSearch ? 
//           '{ ?y lmf:hasLemma ?dl . \n'+
//           'values ?dl { "'+searchTerm+'"@nl "'+searchTerm+'" } } . \n' 
//           : 
//           'FILTER regex(?lemma, "'+searchTerm+'") .\n';

//   // query
  
//   return 'PREFIX duelme: <http://rdf.ivdnt.org/lexica/duelme>\n'+        
//         'PREFIX intskos: <http://ivdnt.org/schema/lexica#>\n'+
//         'PREFIX lmf: <http://www.lexinfo.net/lmf>\n'+
//         'PREFIX ontolex: <http://www.w3.org/ns/lemon/ontolex#>\n'+
//         'PREFIX UD: <http://rdf.ivdnt.org/vocabs/UniversalDependencies2#>\n'+
//         'PREFIX prov: <http://www.w3.org/ns/prov#>\n'+
//         'PREFIX dcterms: <http://purl.org/dc/terms/>\n'+
//         '\n'+
//         'SELECT DISTINCT (?d AS ?colorId) ?exampleSentence ?lemma ?gender ?number ?attestation ?source\n'+
//         'WHERE  {\n'+        
//         '      ?d intskos:ExampleSentence ?exampleSentence .\n'+
//         '      ?d lmf:ListOfComponents [lmf:Component ?y] .\n'+
//         '      ?y lmf:hasLemma ?lemma . \n'+
//         '     {'+subpart+'}\n'+
//         '      OPTIONAL { \n'+
//         '        ?d intskos:hasAttestation ?m . \n'+
//         '        ?m prov:value ?attestation . \n'+
//         '        ?m prov:wasQuotedFrom ?pub . \n'+
//         '        ?pub dcterms:title ?source . \n'+
//         '      } \n'+
//         '      OPTIONAL {?y UD:Gender ?gender}\n'+
//         '      OPTIONAL {?y UD:Number ?number}\n'+
//         '}\n';
// };


export function  buildDuelMeCelexQuery(searchTerm){

    // exact or regex match? 

    var exactSearch = !utils.containsRegex(searchTerm);

    // values to match 

    var subpart = exactSearch ? 
            '{ ?c ontolex:canonicalForm [ontolex:writtenRep ?lemma] . \n'+
            'values ?lemma { "'+searchTerm+'"@nl "'+searchTerm+'" } } . \n' 
            : 
            'FILTER regex(?lemma, "'+searchTerm+'") .\n';

    // query
    
    return 'PREFIX duelme: <http://rdf.ivdnt.org/lexica/duelme>\n'+
          'PREFIX celex: <http://rdf.ivdnt.org/lexica/celex/>\n'+
          'PREFIX intskos: <http://ivdnt.org/schema/lexica#>\n'+
          'PREFIX lmf: <http://www.lexinfo.net/lmf>\n'+
          'PREFIX ontolex: <http://www.w3.org/ns/lemon/ontolex#>\n'+
          'PREFIX UD: <http://rdf.ivdnt.org/vocabs/UniversalDependencies2#>\n'+
          '\n'+
          'SELECT ?exampleSentence ?lemma ?wordform ?gender ?number\n'+
          'WHERE  {\n'+
          '    GRAPH duelme: {\n'+
          '        ?d intskos:ExampleSentence ?exampleSentence .\n'+
          '        ?d lmf:ListOfComponents [lmf:Component ?y] .\n'+
          '        ?y lmf:hasLemma ?lemma . \n'+
          '        OPTIONAL {?y UD:Gender ?gender}\n'+
          '        OPTIONAL {?y UD:Number ?number}\n'+
          '    }\n'+
          '    GRAPH celex: {\n'+
          '        '+subpart+'\n'+
          '        ?c ontolex:canonicalForm [ontolex:writtenRep ?lemma] .\n'+
          '        ?c ontolex:lexicalForm ?lexform .\n'+
          '        ?lexform ontolex:writtenRep ?wordform .\n'+
          '        OPTIONAL {?lexform UD:Number ?number}\n'+
          '        OPTIONAL {\n'+
          '        ?c UD:Gender ?g .\n'+
          '        bind(\n'+
          '            if(?g = UD:Fem_Gender, \n'+
          '                UD:Fem, \n'+
          '                if(?g = UD:Masc_Gender, \n'+
          '                    UD:Masc, \n'+
          '                    UD:Neut\n'+
          '                )\n'+
          '            )\n'+
          '            AS ?gender\n'+
          '        )\n'+
          '        }\n'+          
          '    }\n'+
          '}  \n';
};



// MOLEX

export function buildMolexQuery(searchTerm){

    // exact or regex match? 
    
    var exactSearch = !utils.containsRegex(searchTerm);

    // values to match
    
    var subpart1 = exactSearch ? 
        '{ ?lemCFId ontolex:writtenRep ?lemma . \n'+
        'values ?lemma { "'+searchTerm+'"@nl "'+searchTerm+'" } }  \n'+
        'UNION \n'+
        '{ ?wordformId ontolex:writtenRep ?wordform . \n'+
        'values ?wordform { "'+searchTerm+'"@nl "'+searchTerm+'" } } .\n' 
        : 
        '';
    var subpart2 = exactSearch ? '' : 'FILTER ( regex(?lemma, "'+searchTerm+'") || regex(?wordform, "'+searchTerm+'") ) . \n';
    
    // query
    
    return 'PREFIX ontolex: <http://www.w3.org/ns/lemon/ontolex#>\n'+
        'PREFIX UD: <http://universaldependencies.org/u/>\n'+
        'PREFIX diamant: <http://rdf.ivdnt.org/schema/diamant#>\n'+
        '\n'+
        'SELECT DISTINCT (?lemEntryId AS ?colorId) ?lemEntryId ?lemma ?lemPos ?wordformId ?wordform ?hyphenation ?wordformPos ?Gender ?Number\n'+
        'FROM <http://rdf.ivdnt.org/lexica/molex>\n'+
        'WHERE\n'+
        '{\n'+
        '    ?lemEntryId ontolex:canonicalForm ?lemCFId . \n'+
        '    ?lemCFId ontolex:writtenRep ?lemma . \n'+
        '    '+subpart1+'\n'+
        '    OPTIONAL {?lemEntryId UD:Gender ?Gender .}\n'+
        '    OPTIONAL {?lemEntryId UD:VerbForm ?verbform .}\n'+
        '    ?lemEntryId UD:pos ?lemPos .\n'+
        '    ?lemEntryId ontolex:lexicalForm ?wordformId .\n'+
        '    ?wordformId UD:pos ?wordformPos .\n'+
        '    OPTIONAL {?wordformId UD:Number ?Number .} \n'+     
        '    OPTIONAL {?wordformId ontolex:writtenRep ?wordform .}\n'+
        '    OPTIONAL {?wordformId diamant:hyphenation ?hyphenation .}  \n'+
        '    '+subpart2+' \n'+
        '}  ORDER BY ?lemEntryId ?gender  \n';
};



// DIAMANT

export function buildDiamantQuery(searchTerm){

    // exact or regex match? 
    
    var exactSearch = !utils.containsRegex(searchTerm);

    // values to match
    
    var subpart1 = exactSearch ? 
        '{ ?canonicalFormID ontolex:writtenRep ?l . \n'+
        'values ?l { "'+searchTerm+'"@nl "'+searchTerm+'" } }  .\n'
        : 
        'FILTER regex(?lemma, "'+searchTerm+'") .\n';
    var subpart2 = exactSearch ? 
        '{ ?synDefId diamant:definitionText ?dt . \n'+
        'values ?dt { "'+searchTerm+'"@nl "'+searchTerm+'" } }  .\n'
        : 
        'FILTER regex(?syndefDefinitionText, "'+searchTerm+'") .\n';

    var subpart3 = exactSearch ? 
        '{ ?senseDefId diamant:definitionText ?dft . \n'+
        'values ?dft { "'+searchTerm+'"@nl "'+searchTerm+'" } }  .\n'
        : 
        'FILTER regex(?sensedefDefinitionText, "'+searchTerm+'") .\n';

    // include Jesse's style ? (default: false)
    var spec = false;
    
    // query
    
    return 'PREFIX xsd: <http://www.w3.org/2001/XMLSchema#>\n'+
        'PREFIX prov: <http://www.w3.org/ns/prov#>\n'+
        'PREFIX diamant: <http://rdf.ivdnt.org/schema/diamant#>\n'+
        'PREFIX lexinfo: <http://www.lexinfo.net/ontology/2.0/lexinfo#>\n'+
        'PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>\n'+
        'PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>\n'+
        'PREFIX lemon: <http://lemon-model.net/lemon#>\n'+
        'PREFIX ontolex: <http://www.w3.org/ns/lemon/ontolex#>\n'+
        'PREFIX ud: <http://universaldependencies.org/u/pos/>\n'+
        'PREFIX skos: <http://www.w3.org/2004/02/skos/core#>\n'+
        'PREFIX dcterms: <http://purl.org/dc/terms/>\n'+
        'PREFIX dc: <http://purl.org/dc/terms/>\n'+
        '\n'+
        'SELECT DISTINCT (?entryId AS ?colorId) ?entryId ?lemma ?pos ?senseDefId ?sensedefDefinitionText ?syndefDefinitionText ?senseId  ?witnessYearFrom ?witnessYearTo\n'+
        'WHERE\n'+
        '{\n'+
        '    {\n'+
        '    ?entryId ontolex:canonicalForm ?canonicalFormID . \n'+
        '    ?canonicalFormID ontolex:writtenRep ?lemma . \n'+
        '    '+subpart1+' \n'+
        '    ?entryId ontolex:sense ?senseId . \n'+
        '    ?senseId lemon:definition ?synDefId . \n'+
        '    ?senseId lemon:definition ?senseDefId . \n'+
        '    ?senseId diamant:attestation ?attestationId . \n'+
        '    ?attestationId diamant:text ?quotationId . \n'+
        '    ?senseDefId diamant:definitionText ?sensedefDefinitionText . \n'+
        '    ?synDefId diamant:definitionText ?syndefDefinitionText . \n'+
        '    OPTIONAL { ?quotationId diamant:witnessYearFromShow ?witnessYearFrom . } \n'+
        '    OPTIONAL { ?quotationId diamant:witnessYearToShow ?witnessYearTo . } \n'+
        (spec ? 
        '    { ?entryId a ontolex:LexicalEntry} .\n'+
        '    { ?canonicalFormID a ontolex:Form} .\n'+
        '    { ?senseId a ontolex:LexicalSense} .\n'+
        '    { ?synDefId a diamant:SynonymDefinition} .\n'+
        '    { ?senseDefId a lemon:SenseDefinition} .\n'+
        '    ?attestationId a diamant:Attestation .\n'+
        '    ?quotationId a diamant:Quotation .\n'
        : 
        ''
        )+
        '    }\n'+
        '    UNION\n'+
        '    {\n'+
        '    ?canonicalFormID ontolex:writtenRep ?lemma . \n'+
        '    ?synDefId diamant:definitionText ?syndefDefinitionText . \n'+
        '    { {'+subpart2+'} UNION {'+subpart3+'} } \n'+
        '    ?entryId ontolex:sense ?senseId . \n'+
        '    ?senseId lemon:definition ?synDefId . \n'+
        '    ?senseId lemon:definition ?senseDefId . \n'+
        '    ?senseDefId diamant:definitionText ?sensedefDefinitionText . \n'+
        '    ?entryId ontolex:canonicalForm ?canonicalFormID . \n'+
        '    ?senseId diamant:attestation ?attestationId . \n'+
        '    ?attestationId diamant:text ?quotationId . \n'+
        (spec ? 
        '    { ?senseId a ontolex:LexicalSense} .\n'+
        '    { ?synDefId a diamant:SynonymDefinition} .\n'+
        '    { ?senseDefId a lemon:SenseDefinition} .\n'+
        '    { ?canonicalFormID a ontolex:Form} .\n'+
        '    { ?entryId a ontolex:LexicalEntry} .\n'+
        '    ?attestationId a diamant:Attestation .\n'+
        '    ?quotationId a diamant:Quotation .\n'
        : 
        ''
        )+
        '    OPTIONAL { ?quotationId diamant:witnessYearFrom ?witnessYearFrom . } \n'+
        '    OPTIONAL { ?quotationId diamant:witnessYearTo ?witnessYearTo . } \n'+
        '    }\n'+
        '}\n';
};

export default simpleQueryBuilder;


// WEBPACK FOOTER //
// ./src/js/simpleQueryBuilder.js